import LockIcon from "@/assets/images/lock.png";
import { Button, Container, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

interface RestrictedProps extends React.HTMLAttributes<HTMLDivElement> {
  accessMessage?: string;
}

export const Restricted = ({ className, accessMessage }: RestrictedProps) => {
  return (
    <div data-testid="restricted-page" className={clsx("flex flex-1 bg-city bg-contain bg-[center_bottom_-2rem] bg-no-repeat", className)}>
      <Container className="flex max-w-sm flex-col items-center px-5 pb-32 pt-[14vh]">
        <img src={LockIcon} alt="Restricted Access" className="max-w-[128px]" />
        <Typography variant="title" className="mb-4 !text-[24px] sm:!text-[32px]">
          Restricted Access
        </Typography>
        <Typography variant="paragraph" className="text-center text-neutral-dark-gray">
          {accessMessage || "The page you're trying to access has restricted access. Please refer to your system administrator."}
        </Typography>
        <Button onClick={() => history.back()} className="mt-8" size="lg">
          Go Back
        </Button>
      </Container>
      <div className="pointer-events-none fixed bottom-0 min-h-[50%] w-full bg-city bg-cover bg-no-repeat" />
    </div>
  );
};
